import zhTW from './zh-TW';
import en from './en';
import ja from './ja';

const translations = {
  'zh-TW': zhTW,
  en,
  ja,
};

export default translations;
